<template>
  <div class="item_extend">
    <RowCard
      :theme="theme"
      style="position: relative; padding: 24px 33px 24px 16px; gap: 0"
      :style="item.status == 'Draft' ? { color: '#F15A29' } : { color: '#000' }"
    >
      <div :style="{ width: headers[0].width }" class="flex-center gap-4">
        <v-btn v-if="item.status == 'Draft'" small icon @click="onDelete">
          <Iconify
            style="color: #b1b1b1"
            icon="basil:trash-alt-solid"
            size="15px"
          ></Iconify>
        </v-btn>
      </div>

      <div :style="{ width: headers[1].width, textAlign: headers[1].align }">
        {{ index + 1 }}
      </div>

      <div
        :style="{ width: headers[2].width, textAlign: headers[2].align }"
        class="text-decoration-underline"
      >
        #{{ item?.fiscal_year }}
      </div>

      <div :style="{ width: headers[3].width, textAlign: headers[3].align }">
        <div class="txt-short">
          <tooltip-text :text="item?.main_project.name" />
        </div>
        <div class="txt-short mt-3 font-w-400 font-ch" style="font-weight: 400">
          <tooltip-text
            :text="
              'รอบที่' +
              item?.round +
              ' : ' +
              toDateTimeFormat(item?.main_project.start_date) +
              ' - ' +
              toDateTimeFormat(item?.main_project.end_date)
            "
          />
        </div>
      </div>

      <div
        :style="{
          width: headers[4].width,
          textAlign: headers[4].align,
          color: checkStatus(item?.status).color,
        }"
      >
        {{ item?.region }}
      </div>

      <div
        :style="{
          width: headers[5].width,
          textAlign: headers[5].align,
          color: checkStatus(item?.status).color,
        }"
      >
        {{ item?.status }}
      </div>

      <v-btn
        absolute
        top
        right
        icon
        :class="{ rotate180: isExpanded }"
        @click="seeDetail"
      >
        <Iconify
          icon="material-symbols:keyboard-arrow-down"
          color="#D3D3D3"
        ></Iconify>
      </v-btn>
    </RowCard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content d-flex flex-column gap-12">
        <v-layout class="font-12 font-w-700" style="color: #b1b1b1">
          <v-flex xs1></v-flex>
          <v-flex xs8>แผนงาน</v-flex>
          <v-flex xs3 class="text-center">สถานะ</v-flex>
        </v-layout>
        <v-divider />
        <v-layout
          align-center
          class="font-12 font-w-500"
          v-for="(plan, i) in item.main_project.plan"
          :key="i"
        >
          <v-flex xs1>
            <v-btn icon v-if="item.status != 'Approved'" @click="onEdit(plan)">
              <Iconify
                icon="solar:pen-2-bold"
                color="#F15A29"
                size="20px"
              ></Iconify>
            </v-btn>
            <v-btn v-else icon @click="onView(plan)">
              <Iconify
                icon="ic:baseline-remove-red-eye"
                color="#3F3F3F"
                size="20px"
              ></Iconify>
            </v-btn>
          </v-flex>
          <v-flex
            xs8
            :style="
              plan.status == 'Draft' ? { color: '#b1b1b1' } : { color: '#000' }
            "
            class="font-w-500"
          >
            {{ plan.plan_master.plan_name_th }}
          </v-flex>
          <v-flex
            :style="
              plan.status == 'Draft' ? { color: '#b1b1b1' } : { color: '#000' }
            "
            xs3
            class="text-center font-w-500"
          >
            <div
              :style="
                plan.pending_sub_group && plan.pending_sub_group.status == 'Created'
                  ? { color: '#FBB040' }
                  : { color: '#5CB844' }
              "
              class="font-w-600"
            >
              {{ plan.pending_sub_group?.status }}
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <!-- <pre>
      {{ item }}
    </pre> -->
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import {
  toDateFormat,
  toDateTimeFormat,
  formatNumber,
} from "@/plugins/global-funcs";

export default {
  components: {
    Button,
    RowCard,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      toDateFormat,
      toDateTimeFormat,
      formatNumber,
      theme: 2,
      rand: "cl-" + Math.random().toString().slice(2),
      isExpanded: false,
    };
  },
  methods: {
    seeDetail() {
      let growDiv = document.querySelector("." + this.rand + ".expand-layout");
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.isExpanded = false;
      } else {
        let wrapper = document.querySelector(
          "." + this.rand + " .expand-content"
        );
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.isExpanded = true;
      }
    },
    checkStatus(status) {
      if (status == "Submitted") {
        this.theme = 1;
        return {
          color: "#F9BB43",
          text: "รอพิจารณา",
        };
      } else if (status == "Reject") {
        this.theme = 4;
        return {
          color: "#F15A29",
          text: "ปฏิเสธขยายเวลา",
        };
      } else if (status == "Approved") {
        this.theme = 3;
        return {
          color: "#5CB844",
          text: "อนุมัติขยายเวลา",
        };
      } else {
        // Draft
        this.theme = 2;
        return {
          color: "#F15A29",
          text: "แบบร่าง",
        };
      }
    },
    onEdit(val) {
      let pending_group_id = this.item.id;
      let plan_id = val.id;
      let pending_sub_group = val.pending_sub_group.id;
      this.$router.push(
        `/sp/extend-time/${pending_group_id}/${plan_id}/form/${pending_sub_group}`
      );
    },
    onView(val) {
      console.log("onView", val);
      let pending_sub_group = val.pending_sub_group.id;
      this.$router.push(`/sp/extend-time/detail/${pending_sub_group}`);
    },
    onDelete() {
      this.$emit("onDelete", this.item.id);
    },
    extendRequest() {
      this.dialog = true;
    },
    onSendExtendTime() {
      console.log("onSendExtendTime");
      this.$emit("onSendExtendTime", this.item.id);
      this.dialog = false;
    },
    extendTime(plan_id) {
      let pending_group_id = this.item.id;
      this.$router.push(`/rsp/extend-time/${pending_group_id}/${plan_id}/form`);
    },
  },
};
</script>

<style scoped lang="scss">
.item_extend {
  .btn_gradient {
    background: linear-gradient(90deg, #f15a29 0%, #fbb040 100%) !important;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25) !important;
    color: #fff !important;
  }
}
.btn_gradient {
  background: linear-gradient(90deg, #f15a29 0%, #fbb040 100%) !important;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25) !important;
  color: #fff !important;
}
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>
